// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-pageContainer-PL4xT {
	width: 100%;
	max-width: var(--max-content-width);
	margin: 30px auto 30px auto;
}

.Dashboard-containerResponsive-hN65p {
	max-width: var(--max-content-width);
	margin: 0 auto;
	width: 100%;
	display: block;
}

.Dashboard-slideShow-QFcBY {
	position: relative;
	height: auto;
	width: 100%;
	max-width: 120px;
	margin: 0 auto;
}

.Dashboard-slideShowImages-AeawR {
	list-style: none;
	margin: 0;
	padding: 0;
}

.Dashboard-slideShowImages-AeawR {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--secondary-gray-bg);
}

.Dashboard-imgResponsive-zn7aH {
	width: 100%;
	height: auto;
	border-radius: 50%;
}

.Dashboard-dashBoardSideMenu-FirKY {
	padding: 25px;
	border: 1px solid var(--primary-border);
	border-radius: 8px;
}

.Dashboard-messageCountText-zBJZ0 {
	margin: 0px 0px 30px 0px;
	font-size: 16px;
}

.Dashboard-waveHandImage-dgDsA {
	display: inline-block;
	width: 26px;
	vertical-align: top;
	margin-right: 11px;
}

.Dashboard-waveHandImageSection-FJZXY {
	display: inline-block;
	width: 83%;
	vertical-align: middle;
}

.Dashboard-dashBoardSideMenuBox-jugiZ {
	border: 1px solid var(--primary-border);
	border-radius: 4px;
	padding: 16px 18px;
}

.Dashboard-menuIcons-TSD6v {
	display: table-cell;
	vertical-align: top;
	width: 20px;
	padding-right: 8px;
}

.Dashboard-menuIconsTexts-U6Jt9 {
	display: table-cell;
	width: 91%;
	font-size: 14px;
	line-height: 20px;
	color: var(--primary-foreground);
	font-weight: 500;
}

.Dashboard-pullRight-jNWJY {
	float: right;
}

.Dashboard-noTextDecoration-zpVUM {
	text-decoration: none !important;
}

.Dashboard-reviewHeading-AfBq_ {
	font-size: 16px;
	display: block;
	color: var(--primary-foreground);
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
	border-radius: 8px;
}

.Dashboard-reviewHeading-AfBq_:hover {
	color: var(--primary-foreground);
}

.Dashboard-hr-BXHWR {
	border-top: 1px solid var(--primary-border);
	margin: 20px 0px;
}

.Dashboard-trashIcon-q06xL {
	position: absolute;
	top: 2px;
	right: 2px;
	width: 22px;
	height: 22px;
	background: var(--common-black-primary-bg);
	padding-top: 3px;
	border: 0;
	border-radius: 2px;
	opacity: .9;
	color: var(--common-primary-white-foreground);
	cursor: pointer;
}

.Dashboard-displayFlexIcons-A5pGe {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Dashboard-profileIcon-DXdPr {
	width: 17px;
	margin: 0px 8px 3px 0px;
}

.Dashboard-menuActive-mQCBf .Dashboard-activBtn-ScIbO {
	background-color: #F8F7FD;
}

.Dashboard-profilePhotoWidth-ubeyW {
	width: 100%;
	position: relative;
	max-width: 253px;
	margin: 0 auto;
}

.Dashboard-photoRemoveText-eqD8I {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-top: 12px;
	font-size: 16px;
	line-height: normal;
	font-weight: 400;
	text-align: center;
}

.Dashboard-photoRemoveText-eqD8I a,
.Dashboard-photoRemoveText-eqD8I a:hover,
.Dashboard-photoRemoveText-eqD8I a:focus {
	color: var(--primary-link-foreground);
	cursor: pointer;
}

@media screen and (max-width: 767px) {
	.Dashboard-menuIconsTexts-U6Jt9 {
		width: 100%;
	}

	.Dashboard-menuIconsTexts-U6Jt9 {
		width: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,mCAAmC;CACnC,2BAA2B;AAC5B;;AAEA;CACC,mCAAmC;CACnC,cAAc;CACd,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,0CAA0C;AAC3C;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,UAAU;CACV,eAAe;CACf,iBAAiB;CACjB,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gCAAgC;CAChC,kBAAkB;CAClB,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,WAAW;CACX,YAAY;CACZ,0CAA0C;CAC1C,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,WAAW;CACX,6CAA6C;CAC7C,eAAe;AAChB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;;CAGC,qCAAqC;CACrC,eAAe;AAChB;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,WAAW;CACZ;AACD","sourcesContent":[".pageContainer {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tmargin: 30px auto 30px auto;\n}\n\n.containerResponsive {\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\twidth: 100%;\n\tdisplay: block;\n}\n\n.slideShow {\n\tposition: relative;\n\theight: auto;\n\twidth: 100%;\n\tmax-width: 120px;\n\tmargin: 0 auto;\n}\n\n.slideShowImages {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.slideShowImages {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n.imgResponsive {\n\twidth: 100%;\n\theight: auto;\n\tborder-radius: 50%;\n}\n\n.dashBoardSideMenu {\n\tpadding: 25px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n}\n\n.messageCountText {\n\tmargin: 0px 0px 30px 0px;\n\tfont-size: 16px;\n}\n\n.waveHandImage {\n\tdisplay: inline-block;\n\twidth: 26px;\n\tvertical-align: top;\n\tmargin-right: 11px;\n}\n\n.waveHandImageSection {\n\tdisplay: inline-block;\n\twidth: 83%;\n\tvertical-align: middle;\n}\n\n.dashBoardSideMenuBox {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 4px;\n\tpadding: 16px 18px;\n}\n\n.menuIcons {\n\tdisplay: table-cell;\n\tvertical-align: top;\n\twidth: 20px;\n\tpadding-right: 8px;\n}\n\n.menuIconsTexts {\n\tdisplay: table-cell;\n\twidth: 91%;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: var(--primary-foreground);\n\tfont-weight: 500;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.noTextDecoration {\n\ttext-decoration: none !important;\n}\n\n.reviewHeading {\n\tfont-size: 16px;\n\tdisplay: block;\n\tcolor: var(--primary-foreground);\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 8px;\n}\n\n.reviewHeading:hover {\n\tcolor: var(--primary-foreground);\n}\n\n.hr {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 20px 0px;\n}\n\n.trashIcon {\n\tposition: absolute;\n\ttop: 2px;\n\tright: 2px;\n\twidth: 22px;\n\theight: 22px;\n\tbackground: var(--common-black-primary-bg);\n\tpadding-top: 3px;\n\tborder: 0;\n\tborder-radius: 2px;\n\topacity: .9;\n\tcolor: var(--common-primary-white-foreground);\n\tcursor: pointer;\n}\n\n.displayFlexIcons {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.profileIcon {\n\twidth: 17px;\n\tmargin: 0px 8px 3px 0px;\n}\n\n.menuActive .activBtn {\n\tbackground-color: #F8F7FD;\n}\n\n.profilePhotoWidth {\n\twidth: 100%;\n\tposition: relative;\n\tmax-width: 253px;\n\tmargin: 0 auto;\n}\n\n.photoRemoveText {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 12px;\n\tfont-size: 16px;\n\tline-height: normal;\n\tfont-weight: 400;\n\ttext-align: center;\n}\n\n.photoRemoveText a,\n.photoRemoveText a:hover,\n.photoRemoveText a:focus {\n\tcolor: var(--primary-link-foreground);\n\tcursor: pointer;\n}\n\n@media screen and (max-width: 767px) {\n\t.menuIconsTexts {\n\t\twidth: 100%;\n\t}\n\n\t.menuIconsTexts {\n\t\twidth: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Dashboard-pageContainer-PL4xT`,
	"containerResponsive": `Dashboard-containerResponsive-hN65p`,
	"slideShow": `Dashboard-slideShow-QFcBY`,
	"slideShowImages": `Dashboard-slideShowImages-AeawR`,
	"imgResponsive": `Dashboard-imgResponsive-zn7aH`,
	"dashBoardSideMenu": `Dashboard-dashBoardSideMenu-FirKY`,
	"messageCountText": `Dashboard-messageCountText-zBJZ0`,
	"waveHandImage": `Dashboard-waveHandImage-dgDsA`,
	"waveHandImageSection": `Dashboard-waveHandImageSection-FJZXY`,
	"dashBoardSideMenuBox": `Dashboard-dashBoardSideMenuBox-jugiZ`,
	"menuIcons": `Dashboard-menuIcons-TSD6v`,
	"menuIconsTexts": `Dashboard-menuIconsTexts-U6Jt9`,
	"pullRight": `Dashboard-pullRight-jNWJY`,
	"noTextDecoration": `Dashboard-noTextDecoration-zpVUM`,
	"reviewHeading": `Dashboard-reviewHeading-AfBq_`,
	"hr": `Dashboard-hr-BXHWR`,
	"trashIcon": `Dashboard-trashIcon-q06xL`,
	"displayFlexIcons": `Dashboard-displayFlexIcons-A5pGe`,
	"profileIcon": `Dashboard-profileIcon-DXdPr`,
	"menuActive": `Dashboard-menuActive-mQCBf`,
	"activBtn": `Dashboard-activBtn-ScIbO`,
	"profilePhotoWidth": `Dashboard-profilePhotoWidth-ubeyW`,
	"photoRemoveText": `Dashboard-photoRemoveText-eqD8I`
};
module.exports = ___CSS_LOADER_EXPORT___;
